import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import {browserHistory} from 'react-router';
import $ from 'jquery';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

class Web_Otpverify extends Component{
  
    constructor(props){
    super(props);
    this.state={
      mobile: localStorage.mobile_number,
    }
    this.resendOtp = this.resendOtp.bind(this);
  }

  componentWillMount(){
    localStorage.removeItem('h_type');
  }
  componentDidMount(){
    this.refs.otp.focus();
  }
  resendOtp()
  {
      var mobile='';
      if(localStorage.mobile_number)
      {
        mobile=localStorage.getItem('mobile_number');
      }
      else if(localStorage.mobile)
      {
        mobile=localStorage.getItem('mobile');
      }
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1= {from: 'desktop_web',mobile: mobile,device_id:localStorage.getItem('push_device_id')};
      var data2= JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'resendOtp',
          data: {req:data2},
          dataType: 'json',
          success: function(data){
            // console.log(data);
          },
          error: function(err){
            // console.log("Resend Otp Error"+err);
          }
      });
  }

  handleFormSubmit(formProps)
  {
    //this.props.Otpverify(formProps);
  var mobile='';
  if(localStorage.mobile_number){
    mobile=localStorage.getItem('mobile_number');
  }
  else if(localStorage.mobile)
  {
    mobile=localStorage.getItem('mobile');
  }
  // var mobile = localStorage.getItem('mobile_number');

  var baseUrl='https://aquadeals.in/admin/web3/user/';
  var pwd = localStorage.getItem('pwd');
  var data1={from:'desktop_web',mobile: mobile,otp:formProps.otp, pwd: pwd}; 
  var data2 = JSON.stringify(data1);
if(formProps.otp){
var button = $('.otp_v');
    button.html("loading...");
    button.prop("disabled",true);

        $.ajax({
          method: 'POST',
          url:baseUrl+'verifyOtp',
          dataType:'json',
          data: {req:data2},
          success: function(data){
                button.html("verify");
                button.prop("disabled",false);
            if(data.status === 'fail'){
              $('#otp_err').text('Invalid verification code');
            }else
            if(data.status === 'success'){
        localStorage.setItem('pwd',data.pwd);
        localStorage.setItem('token',data.user[0].token);
        localStorage.setItem('user_id',data.user[0].id);
         if(localStorage.token && localStorage.w_r_s_dt){
          browserHistory.push(localStorage.w_r_s_dt)
          localStorage.setItem('sprice','1')
          localStorage.removeItem('pprice');
          window.location.reload();
        }
        if(localStorage.token && localStorage.w_r_p_dt){
          browserHistory.push(localStorage.w_r_p_dt)
          localStorage.setItem('pprice','1');
          localStorage.removeItem('sprice');
          window.location.reload();
        }
        if(localStorage.token && localStorage.w_r_seed_deals){
          browserHistory.push(localStorage.w_r_seed_deals)
          window.location.reload();
        }
        if(localStorage.token && localStorage.w_r_p_deals){
          browserHistory.push(localStorage.w_r_p_deals)
          window.location.reload();
        }
        if(localStorage.token && localStorage.w_r_e_s_dt){
          browserHistory.push(localStorage.w_r_e_s_dt);
          window.location.reload();
        }
        if(localStorage.token && localStorage.w_r_e_p_dt){
          browserHistory.push(localStorage.w_r_e_p_dt);
          window.location.reload();
        }
        else if(localStorage.token && localStorage.w_r_e_p_dt){
          browserHistory.push(localStorage.w_r_e_p_dt)
          window.location.reload();
        }
        else  if(localStorage.token && data.status==="success" && !localStorage.w_r_s_dt && !localStorage.w_r_p_dt && !localStorage.w_r_e_s_dt && !localStorage.w_r_e_p_dt && !localStorage.w_r_seed_deals && !localStorage.w_r_p_deals ){
          browserHistory.push('/web/home');
          window.location.reload();
        }             

            }
            // button.prop("disabled",false);
            // button.html("create account");
            // if(data.status === 'referror'){
            // $("#ref_err").text(data.message); 
            // }
            // if(data.status === 'error'){
            // $("#email_err").text(data.message);
            // }

        },
        error: function(err){
          button.prop("disabled",false);
          button.html("create account");          
          // console.log("Error"+err);
        }
        });
  }
}

componentWillReceiveProps(newProps) {
}
  render(){
  $('#otp_input').keyup(function() {
            $('#otp_err').text('');
  });
  const {handleSubmit,fields:{otp}} = this.props;
  return (
      <div className="lgt_gry web_deals web_otpverify_page">
          <WebHeaderInner />
          <section className="container dels_cntnt">
              <div className="row">
                <div className="col-md-12 del_rgt">
                  <div className="del_rgt_blk">
                    <div className="del_dtl">
                    <div className="clr">&nbsp;</div>
                        <div className="">
                            <div className="col-md-6 col-md-offset-3">
                              <div className="thumbnail">
                                <div className="newlogin_logo"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt=" "/></div>
                                <div>
                                    <form className="mtrl_elmnts" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                                        <div className="col-md-12">
                                            <div className="col-md-12 col-xs-12 col-sm-12">
                                                <div className="group">      
                                                  <input {...otp} type="text" required id="otp_input" ref="otp" />
                                                  <span className="highlight"></span>
                                                  <span className="bar"></span>
                                                  <span style={{color:'red'}} id="otp_err"></span>
                                                  <label>Enter OTP</label>
                                                </div>
                                            </div>
                                            <button action="submit" className="btn web_otpverify_btn otp_v">Verify <i className="glyphicon glyphicon-menu-right"></i></button>
                                        </div>
                                        <div className="clr">&nbsp;</div>
                                        <div className="clr">&nbsp;</div>
                                        <div className="forgot_pasword">
                                            <h5>Didn't recieve the OTP?</h5>
                                            <div className="tap" >
                                                <a onClick={this.resendOtp}>Tap here to resend</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="clr">&nbsp;</div>
                              </div>                  {/*    <!-- login form end --> */}
                          </div>
                        </div>
                        <div className="clr">&nbsp;</div>
                        <div className="clr">&nbsp;</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clr">&nbsp;</div> 
              <div className="clr">&nbsp;</div>
            </section>
            <WebFooter />
      </div> 
          );
      }
  }
    function mapStateToProps(state){
      return {
        errorMessage:state.auth.error,
        authenticated:state.auth.authenticated,
        formdata:state.auth.formdata
      };
    }
    export default reduxForm({
      form :'Otpverify',
      fields:['otp'],
    },mapStateToProps,actions)(Web_Otpverify);



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Auth/Web_Otpverify.js
 **/